import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import DiscoveryPointList from './discovery-point-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Discovery Points">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>            
            <Breadcrumb.Item active>Discovery Points</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <DiscoveryPointList />
    </Panel>
  );
};

export default Page;
